(function (angular) {
	angular.module('bizPartEngage').service('core.services.favorite', favoriteService);

	favoriteService.$inject = ["$http"];

	function favoriteService($http) {
		var apiPath = siteRootPath + 'api/favorites/';

		return {
			IsFavorite: IsFavorite,
			AddFavorite: AddFavorite,
			RemoveFavorite: RemoveFavorite,
			GetFavorites: GetFavorites
		};

		function IsFavorite(objectType, objectId) {
			return $http.get(apiPath + 'IsFavorite', {
				params: {
					objectType: objectType,
					objectId: objectId
				}
			});
		}

		function AddFavorite(objectType, objectId) {
			return $http.post(apiPath + 'AddFavorite', {}, {
				params: {
					objectType: objectType,
					objectId: objectId
				}
			});
		}

		function RemoveFavorite(objectType, objectId) {
			return $http.delete(apiPath + 'RemoveFavorite', {
				params: {
					objectType: objectType,
					objectId: objectId
				}
			});
		}

		function GetFavorites(deepload, objectType) {
			var params = {
				deepload: deepload
			};

			if (objectType)
				params.objectType = objectType;

			return $http.get(apiPath + 'GetFavorites', {
				params: params
			});
		}
	}
})(window.angular);
